import { useMutation, useQueryClient } from '@tanstack/react-query';
import steven from 'helpers/steven';
import {
  request,
  type V3ApiSuccessfulResponse,
  type V3ApiFailedResponse,
} from 'javascripts/services/v3ApiClient';
import { PageObject } from 'data/v3/data-contracts';
import { PageTemplateId } from '../types';
import { PROJECT_PAGES_QUERY_KEY } from 'data/v3';

type CreatePageFromTemplateResponse = V3ApiSuccessfulResponse<PageObject>;

type CreatePageFromTemplateParams = {
  template_id: PageTemplateId;
};

export const useCreatePageFromTemplate = ({
  projectDbId,
  onSuccess,
  onError,
}: {
  projectDbId: number;
  onSuccess?: (data: PageObject) => void;
  onError?: () => void;
}) => {
  const queryClient = useQueryClient();

  return useMutation<
    CreatePageFromTemplateResponse,
    V3ApiFailedResponse,
    CreatePageFromTemplateParams
  >({
    mutationFn: async (params) => {
      const { template_id } = params;

      return request({
        url: `projects/${projectDbId}/pages/from_template`,
        method: 'post',
        data: {
          template_id,
        },
      });
    },
    onSuccess: async ({ data }: { data: PageObject }) => {
      steven.entityCrud({
        entity_id: `${data.id}`,
        entity_type: 'page',
        action: 'created',
        source: 'template',
      });

      queryClient.invalidateQueries({
        queryKey: [PROJECT_PAGES_QUERY_KEY, projectDbId],
      });

      onSuccess(data);
    },
    onError: () => {
      onError?.();
    },
  });
};
